 import "../css/landing.css"
 import "../css/landingresp.css"
 import logo1 from "../media/whiteFav.png";
import logo3 from "../media/darkLogo.png"
import { useState } from "react";
import { db } from "../firebase/firebase";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import Swal from "sweetalert2";
import { Icon } from "@iconify/react";


 function Footer(){


    const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const saveEmailToFirestore = async () => {
    // Validation
    if (!email.trim()) {
      Swal.fire({
        title: "Email Required",
        text: "Please enter your email address.",
        icon: "warning",
        confirmButtonColor: "#6a5acd",
      });
      return;
    }

    if (!validateEmail(email)) {
      Swal.fire({
        title: "Invalid Email",
        text: "Please enter a valid email address.",
        icon: "error",
        confirmButtonColor: "#6a5acd",
      });
      return;
    }

    setIsLoading(true);

    try {
      // Check if email already exists
      const subscribersRef = collection(db, "Email-Subscribers");
      const q = query(subscribersRef, where("email", "==", email.toLowerCase()));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        Swal.fire({
          title: "Already Subscribed",
          text: "This email is already subscribed to our newsletter.",
          icon: "info",
          confirmButtonColor: "#6a5acd",
        });
        setIsLoading(false);
        return;
      }

      // Save email to Firestore
      await addDoc(subscribersRef, {
        email: email.toLowerCase(),
        subscribedAt: new Date().toISOString(),
        status: "active",
      });

      // Success notification
      Swal.fire({
        title: "Subscribed!",
        text: "Thank you for subscribing to our newsletter. You'll receive updates and early access notifications.",
        icon: "success",
        confirmButtonColor: "#6a5acd",
      });

      // Clear input
      setEmail("");
    } catch (error) {
      console.error("Error saving email:", error);
      Swal.fire({
        title: "Subscription Failed",
        text: "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonColor: "#6a5acd",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      saveEmailToFirestore();
    }
  };
    return(
    <footer>
        <div className="footerPlacer">
          <div className="footerTop">
            <div className="ftLeft">
              <div className="ftTT">
                <img src={logo3} alt="" />
              </div>
              <div className="ftBB">
                <p>All-in-one platform for remote jobs and AI tasks, built to simplify work and maximize earning potential.</p>
              </div>
            </div>
            <div className="ftMid">
              <div className="ftMidLeft">
                     <div className="ftTT">
                      <p>Menu Links</p>
                      </div>
                <div className="ftBB">
                  <a href="/">Home <Icon className="faIcon" icon="solar:arrow-right-up-linear" /></a>
                  <a href="/dashboard">Dashboard <Icon className="faIcon" icon="solar:arrow-right-up-linear" /></a>
                  <a href="/about">About Us <Icon className="faIcon" icon="solar:arrow-right-up-linear" /></a>
                  <a href="/terms-of-service">Terms of Service  <Icon className="faIcon" icon="solar:arrow-right-up-linear" /></a>
                  <a href="/referral-program">Referral Program  <Icon className="faIcon" icon="solar:arrow-right-up-linear" /></a>
                  <a href="privacy-policy">Privacy Policy  <Icon className="faIcon" icon="solar:arrow-right-up-linear" /></a>
                </div>
                
              </div>
            
           
              
            </div>
       <div className="ftRight">
      <div className="ftTT">
        <p>Newsletter</p>
      </div>

      <div className="ftBB">
        <p>Receive news on jobs posted, updates and early access.</p>

        <div className="newsLetterWrap">
          <div className="nlInput">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
            />
          </div>
          <div className="nLBtn" onClick={saveEmailToFirestore}>
            <Icon className="faIcon" icon="solar:plain-3-linear" />
          </div>
        </div>
      </div>
    </div>
            
          </div>
          <div className="footerBtm">
            <span> &copy; 2026 Solara Jobs. All rights reserved. </span>

          </div>

        </div>

      </footer>
    )

 }

 export default Footer